import { render } from "./MDSStatistics.vue?vue&type=template&id=d8c90932"
import script from "./MDSStatistics.vue?vue&type=script&lang=js"
export * from "./MDSStatistics.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__